export const gameUrlFromTitle = (title: string = ''): string => {
  try {
    return title
      .toLowerCase()
      .replace(/\s/gi, '-')
      .replace(/_/gi, '-')
      .replace(/[#?!+=*–./\\@%^&()~':,’‘`]/gi, '')
      .replace(/-{2,3}/g, '-');
  } catch (e) {
    console.error('Error in url creating', e);
    return '';
  }
};
